import React from 'react';
import SponsorPolicyContainer from '../../../Containers/UserContainer/SponsorPolicy';

const SponsorPolicyScreen = () => {
  return <SponsorPolicyContainer />;
};

export default SponsorPolicyScreen;
